module.exports = __webpack_public_path__ + "img/sta_product.fa6c4412.png";